// src/error-boundaries/ErrorBoundary.tsx

import React, { Component, ReactNode } from 'react';
import Button from '@mui/material/Button'; // Import MUI Button

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Error caught by Error Boundary:', error, info);
  }

  render() {
    const { hasError, error } = this.state;
    if (hasError) {
      return (
        <div style={{ textAlign: 'center', marginTop: '150px' }}>
          <h1>Oops! Something went wrong.</h1>
          <p>{error?.message}</p>
          {/* <Button
            variant="contained"
            color="primary" // Uses the primary color from the theme
            onClick={() => window.location.reload()}
          >
            Reload
          </Button> */}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
